import React, { useEffect, useState } from "react";
import styles from "../BuySellOrders.module.scss";
import Table from "../../../../common/Table/Table";
import Tooltip from "../../../../common/Tooltip/Tooltip";
import CopyBtn from "../../../../common/CopyBtn/CopyBtn";
import Button from "../../../../common/Button/Button";
import Commonpagination from "../../../../common/Pagination/Commonpagination";
import { useDispatch, useSelector } from "react-redux";
import sampleImg from "../../../../../assets/images/dummy-profile.png";
import { formatPrice, toFix } from "../../../../../utils/utils";
import MatchConfirm from "../../../../common/Modals/MatchConfirm/MatchConfirm";
import { matchOrderAction } from "../../../../../features/user/userSlice";
import { format } from "date-fns";

const SellOrders = ({
  className,
  page,
  setPage,
  size,
  handleSorting,
  getBuySellOrders,
}) => {
  const dispatch = useDispatch();
  const orders = useSelector((state) => state.users.buySellOrders);
  const walletBalance = useSelector((state) => state.users.walletBalance);
  const [loading, setLoading] = useState(true);
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({});
  const [paymentMode, setPaymentMode] = useState("STRIPE");
  const [balanceObj, setBalanceObj] = useState({});
  const baseURL = orders?.profileUrl;
  const decimalLimit = useSelector((state) => state?.users?.coinDecimals);

  const fields = [
    { label: "Order ID" },
    { label: "User" },
    { label: "Asset" },
    { label: "Quantity", sort: true },
    { label: "Price", sort: true },
    { label: "Total" },
    // { label: "Date/Time" },
    { label: "Action" },
  ];

  useEffect(() => {
    let data = [];
    walletBalance.length > 0 &&
      walletBalance?.forEach((element) => {
        data[element.account_type] = element.amount;
      });
    setBalanceObj(data);
  }, [walletBalance]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1400);
  }, []);

  const handleMatchOrder = async (orderId) => {
    try {
      const dataObj = {
        orderId: selectedOrder?.order_uid,
        type: paymentMode,
      };

      const response = await dispatch(matchOrderAction(dataObj));
      if (response.status === 200) {
        getBuySellOrders();
      }
    } catch (error) { }
  };

  return (
    <>
      <Table
        noRecordContent={"No records for your search were found."}
        noRecordVariant={"large"}
        noRecordClassName={styles.no_content}
        loading={loading}
        fields={fields}
        onClick={(col) => handleSorting(col)}
        className={`${styles.table} ${className}`}
      >
        {orders?.totalItems > 0 &&
          orders?.rows?.map((item) => (
            <tr>
              <td>
                <Tooltip
                  icon={<span>{"..." + item.order_uid.slice(-5)}</span>}
                  content={
                    <>
                      <CopyBtn text={item.order_uid} /> {"..." + item.order_uid.slice(-5)}
                    </>
                  }
                  className={styles.orderId}
                />
              </td>
              <td className={styles.user_details}>
                <img
                  alt="user"
                  src={
                    item?.user?.profile_pic !== null
                      ? baseURL + item?.user?.profile_pic
                      : sampleImg
                  }
                />
                {item?.user?.username?.length > 7
                  ? item?.user?.username?.slice(0, 8) + "..."
                  : item?.user?.username}
              </td>
              <td>{item?.master_tokens_configuration?.name}</td>
              <td>
                {toFix(
                  Number(item.quantity),
                  decimalLimit?.item?.master_tokens_configuration?.name
                )}
              </td>
              <td>${formatPrice(Number(item.price))}</td>
              <td>${formatPrice(Number(item?.price * item?.quantity))}</td>
              {/* <td>
                {item?.created_at &&
                  format(new Date(item?.created_at), "dd/mm/yy hh:mm a")}
              </td> */}
              <td>
                <Button
                  text="Place Order"
                  onClick={() => {
                    setSelectedOrder(item);
                    setConfirmModal(true);
                  }}
                />
              </td>
            </tr>
          ))}
      </Table>
      {orders?.totalItems > 10 && (
        <Commonpagination
          currentPage={page}
          className={styles.pagination}
          pageSize={size}
          totalPages={orders.totalPages}
          handlePageChange={(selected) => setPage(selected)}
        />
      )}
      <MatchConfirm
        show={confirmModal}
        order={selectedOrder}
        handleMatchOrder={handleMatchOrder}
        handleClose={() => setConfirmModal(false)}
        paymentMode={paymentMode}
        setPaymentMode={setPaymentMode}
        balanceObj={balanceObj}
        orderType="BUY"
      />
      {/* //   {sampleData?.length > 0 && (
    //     <Commonpagination
    //     // currentPage={page}
    //     // className={styles.pagination}
    //     // pageSize={pageSize}
    //     // totalPages={totalPages}
    //     // handlePageChange={(selected) => setPage(selected)}
    //     />
    //   )} */}
    </>
  );
};

export default SellOrders;
